import script from "./ArchiveView.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveView.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveView.vue?vue&type=style&index=0&id=7d221a40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d221a40"]])

export default __exports__